import React from 'react';

import { linkRegEx } from '../../utils';

import styles from './styles.css';

type LinkParserProps = {
  children: string;
  completeLink?: string;
  cutLink?: string;
};

const LinkParser = ({
  children: text = '',
  completeLink,
  cutLink,
}: LinkParserProps) => {
  const elements = text.split(linkRegEx);
  const returnCorrectLink = (url: string) => {
    if (url === cutLink) {
      return completeLink;
    }
    return url;
  };

  if (elements.length <= 1) {
    return <>{text}</>;
  }

  return (
    <>
      {elements.map((item, index) => {
        const textItem =
          index === elements.length - 1 ? item : item.concat(' ');
        if (linkRegEx.exec(item)) {
          const url = item.toLowerCase().includes('http')
            ? item
            : 'https://'.concat(item); // assume that the website has a https domain

          const isExternalUrl = !url.includes('xing.com');
          const externalProps = isExternalUrl
            ? {
                target: '_blank',
                rel: 'noopener nofollow',
              }
            : {};

          return (
            <a
              {...externalProps}
              href={returnCorrectLink(url)}
              className={styles.linkContent}
              key={index}
            >
              {textItem}
            </a>
          );
        } else {
          return <React.Fragment key={index}>{textItem}</React.Fragment>;
        }
      })}
    </>
  );
};

export default LinkParser;
